import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DocumentIcon } from 'assets/icon-document.svg';
import { ReactComponent as SearchIcon } from 'assets/icon-search.svg';

import BackgroundBox from 'shared/components/BackgroundBox';
import { LabelIcon } from 'shared/components/Labels';
import { colors } from 'shared/defaultTheme';
import { TextField } from 'shared/components/form/Inputs';
import { Button } from 'shared/components/Buttons';

import { addBreadcrumb, removeBreadcrumb } from 'redux/actions/layoutActions';

import Clients from './components/Clients';
import TreeFolder from './components/TreeFolder';
import { SelectedFolderDocumentWrapper } from './styles';

const SelectedFolderDocument = () => {
  const theme = useSelector((state) => state.theme);
  const { breadcrumbs } = useSelector((state) => state.layout);
  const { isCustomer } = useSelector((state) => state.auth);
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { mainColor } = theme;
  const [searchValue, setSearchValue] = useState(undefined);

  useEffect(() => {
    if (breadcrumbs.length > 1) {
      breadcrumbs.forEach(() => {
        dispatch(removeBreadcrumb());
      });
      dispatch(
        addBreadcrumb({
          active: false,
          label: 'general_home',
          link: '/home',
          isModify: false,
        })
      );
    }
    dispatch(
      addBreadcrumb({
        label: 'general_documentation',
        active: true,
        link: pathname,
        isModify: false,
      })
    );
  }, []);

  const onSearchClients = (e) => {
    if (e) {
      const { value } = e.target;
      setSearchValue(value);
    } else {
      setSearchValue('');
    }
  };

  return (
    <SelectedFolderDocumentWrapper className="pb-3">
      <BackgroundBox className="backgroundbox-wrapper">
        <LabelIcon
          label={t('documents_add_document')}
          Icon={() => <DocumentIcon className="label-icon__document" fill={colors.white} />}
          color={mainColor}
          className="ml-1 label-icon text-uppercase"
          classNameMain="mb-3"
        />
        {isCustomer && (
          <div className="form d-flex justify-content-end mb-3">
            <TextField
              borderRadius={2}
              className="m-0 h-50 w-25"
              inputClassName="w-100"
              withButtonClear
              rightIcon={<SearchIcon fill={colors.black} />}
              onChange={onSearchClients}
              value={searchValue ?? ''}
              placeholder={t('home_search_client')}
            />
          </div>
        )}
        <div className="d-flex justify-content-center">
          {isCustomer && <Clients searchValue={searchValue} />}
          <TreeFolder />
        </div>
        <div className="w-100 mt-4">
          <div className="d-flex flex-row justify-content-end">
            <Button
              className="mr-3 text-uppercase"
              type="button"
              color="secondary"
              label={t('general_button_cancel')}
              onClick={() => history.push('/home')}
            />
            <Button
              className="text-uppercase"
              type="button"
              color="primary"
              label={t('general_add')}
              onClick={() => {
                // dispatch(getDocumentPath(refFileManager.current.path));
                history.push('/documentation', { params: 'new_word' });
              }}
            />
          </div>
        </div>
      </BackgroundBox>
    </SelectedFolderDocumentWrapper>
  );
};

export default SelectedFolderDocument;
